import React from 'react';
import styled from 'styled-components';

const StyledImgIcon = styled.img`
  max-height: 16px;
  width: 20px;
`;

const StyledShortCode = styled.span`
  font-variant: small-caps;
  font-style: normal;
  cursor: default;
  color: white;
  background-color: #333;
  padding: 1px;
  font-size: 80%;
  font-weight: bold;
  border-radius: 2px;
  text-shadow: none;
`;

const RankIcon = ({ rank }) => {
  if (!rank) return null;

  if (rank.icon?.present) {
    return <StyledImgIcon src={rank.icon.url} alt={rank.name} title={rank.name} />;
  }

  if (rank.short_code) {
    return <StyledShortCode title={rank.name}>{rank.short_code}</StyledShortCode>;
  }

  return null;
};

export default RankIcon;
